exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".qb90FI2uVIybRy{background-color:transparent;border:none;box-shadow:none;color:#42526e;padding:0;text-decoration:none}.qb90FI2uVIybRy:active,.qb90FI2uVIybRy:hover{background-color:transparent;border:none;box-shadow:none;color:#172b4d;cursor:pointer;outline:0}", ""]);

// exports
exports.locals = {
	"closeButton": "qb90FI2uVIybRy"
};